import { fetchApi } from './fetch';
import type { Task } from '../types';

export interface SearchResult {
  tasks: Task[];
  query: string;
  isSemanticMode: boolean; // true when OPENAI_API_KEY is configured on the server
}

/**
 * Search tasks using hybrid semantic + full-text search.
 * Returns ranked tasks. Falls back to empty if search is unavailable.
 */
export async function searchTasks(q: string, limit = 10): Promise<SearchResult> {
  const tasks = await fetchApi<Task[]>('/tasks/search', {
    method: 'POST',
    body: JSON.stringify({ q: q.trim(), limit }),
  });
  return {
    tasks: Array.isArray(tasks) ? tasks : [],
    query: q.trim(),
    isSemanticMode: true, // server uses semantic if OPENAI configured, we assume it did
  };
}
